import { createSelector } from "reselect";

import { itemSelectors } from "../../../items";
import { sequenceSelectors } from "../../../sequence";

/**
 * returns an object containing the nested indexes for all children
 * @param {Map} childrenById
 * @param {List} sequence
 * @param {*} children
 * @param {string} superIndex
 */
const getNestedIndexes = (childrenById, sequenceIndexById, children, superIndex) => {
  const prefix = `${superIndex}${superIndex ? "." : ""}`;
  const sortChildren = children.sort((a, b) => sequenceIndexById.get(a) - sequenceIndexById.get(b));
  return sortChildren.reduce(
    // reducer function
    (indexes, id, index) => {
      // const item = itemsById.get(id);
      const myIndex = `${prefix}${index + 1}`;
      indexes[id] = myIndex;
      const itemChildren = childrenById.get(id);
      if (itemChildren.size) {
        const sequenceChildren = itemChildren.filter(id => sequenceIndexById.has(id));
        const newIndexes = getNestedIndexes(childrenById, sequenceIndexById, sequenceChildren, myIndex);
        Object.assign(indexes, newIndexes);
      }
      return indexes;
    },
    // Initial value: empty object
    {}
  );
};

// TODO: Ideally, we would like to separate out the tree structure from the items so that
// this does not need to recalculate just because we change a colour or property.
/**
 * @param {Map} superAndChildrenById
 * @param {List} sequence
 */
export default createSelector(
  // input
  (superAndChildrenById, _sequence) => superAndChildrenById,
  (superAndChildrenById, sequence) => sequence,
  // output
  (superAndChildrenById, sequence) => {
    const childrenById = itemSelectors.getChildrenIdsFromItems(superAndChildrenById);
    const topLevelIds = sequence.filter(id => !superAndChildrenById.get(id).super);
    const sequenceIndexById = sequenceSelectors.getSequenceIndexById(sequence);
    return getNestedIndexes(childrenById, sequenceIndexById, topLevelIds, "");
  }
);
